import switchFunc from 'lib/switchFunc'

import { SvgIconProps } from 'components/Luxkit/SvgIcon'

import LineAppleIcon from 'components/Luxkit/Icons/line/LineAppleAltIcon'
import LineBusIcon from 'components/Luxkit/Icons/line/LineBusIcon'
import LineCarIcon from 'components/Luxkit/Icons/line/LineCarIcon'
import LineChairWithAirplaneIcon from 'components/Luxkit/Icons/line/LineChairWithAirplaneIcon'
import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'
import LineChildWithPlusIcon from 'components/Luxkit/Icons/line/LineChildWithPlusIcon'
import LineClochIcon from 'components/Luxkit/Icons/line/LineClochIcon'
import LineClockWithTickIcon from 'components/Luxkit/Icons/line/LineClockWithTickIcon'
import LineCoffeeIcon from 'components/Luxkit/Icons/line/LineCoffeeIcon'
import LineDelayIcon from 'components/Luxkit/Icons/line/LineDelayIcon'
import LineDiningCreditIcon from 'components/Luxkit/Icons/line/LineDiningCreditIcon'
import LineDollarSignIcon from 'components/Luxkit/Icons/line/LineDollarSignIcon'
import LineDrinksTrayIcon from 'components/Luxkit/Icons/line/LineDrinksTrayIcon'
import LineFlightCreditIcon from 'components/Luxkit/Icons/line/LineFlightCreditIcon'
import LineGlassMartiniAltIcon from 'components/Luxkit/Icons/line/LineGlassMartiniAltIcon'
import LineGlassMartiniIcon from 'components/Luxkit/Icons/line/LineGlassMartiniIcon'
import LineGolfIcon from 'components/Luxkit/Icons/line/LineGolfIcon'
import LineHappyHourIcon from 'components/Luxkit/Icons/line/LineHappyHourIcon'
import LineKidIcon from 'components/Luxkit/Icons/line/LineKidIcon'
import LineNoFeesIcon from 'components/Luxkit/Icons/line/LineNoFeesIcon'
import LineOneWayFlightIcon from 'components/Luxkit/Icons/line/LineOneWayFlightIcon'
import LineParkingCircleIcon from 'components/Luxkit/Icons/line/LineParkingCircleIcon'
import LineReceiptIcon from 'components/Luxkit/Icons/line/LineReceiptIcon'
import LineReturnFlightIcon from 'components/Luxkit/Icons/line/LineReturnFlightIcon'
import LineRoomUpgradeIcon from 'components/Luxkit/Icons/line/LineRoomUpgradeIcon'
import LineSkiLiftIcon from 'components/Luxkit/Icons/line/LineSkiLiftIcon'
import LineSpaCreditIcon from 'components/Luxkit/Icons/line/LineSpaCreditIcon'
import LineTagIcon from 'components/Luxkit/Icons/line/LineTagIcon'
import LineTaxiIcon from 'components/Luxkit/Icons/line/LineTaxiIcon'
import LineTennisBallIcon from 'components/Luxkit/Icons/line/LineTennisBallIcon'
import LineUtensilsIcon from 'components/Luxkit/Icons/line/LineUtensilsIcon'
import LineWellnessIcon from 'components/Luxkit/Icons/line/LineWellnessIcon'
import LineWifiIcon from 'components/Luxkit/Icons/line/LineWifiIcon'
import LineWineBeerIcon from 'components/Luxkit/Icons/line/LineWineBeerIcon'

const INCLUSION_ICONS: Record<
  App.TileInclusion['icon'],
  React.ComponentType<SvgIconProps>
> = {
  apple: LineAppleIcon,
  bed_with_upwards_arrow: LineRoomUpgradeIcon,
  bus: LineBusIcon,
  car: LineCarIcon,
  check: LineCheckIcon,
  childs_face: LineKidIcon,
  childs_face_with_plus: LineChildWithPlusIcon,
  cloche: LineClochIcon,
  clock_with_check: LineClockWithTickIcon,
  clock_with_plus: LineDelayIcon,
  coffee_cup: LineCoffeeIcon,
  crossed_utensils: LineUtensilsIcon,
  crossed_utensils_with_plus: LineDiningCreditIcon,
  dollar_sign_in_circle: LineDollarSignIcon,
  dollar_sign_in_circle_with_line_through: LineNoFeesIcon,
  drink_tray: LineDrinksTrayIcon,
  golf: LineGolfIcon,
  lotus: LineWellnessIcon,
  lotus_with_plus: LineSpaCreditIcon,
  martini_glass: LineGlassMartiniAltIcon,
  p_in_circle: LineParkingCircleIcon,
  plane_with_arrow: LineOneWayFlightIcon,
  plane_with_arrows: LineReturnFlightIcon,
  plane_with_plus: LineFlightCreditIcon,
  receipt: LineReceiptIcon,
  seat_with_plane: LineChairWithAirplaneIcon,
  ski_lift: LineSkiLiftIcon,
  tag: LineTagIcon,
  taxi: LineTaxiIcon,
  tennis_ball: LineTennisBallIcon,
  wifi_signal: LineWifiIcon,
  wine_glass: LineGlassMartiniIcon,
  wine_glass_and_beer_glass: LineWineBeerIcon,
  wine_glass_with_clock: LineHappyHourIcon,
}

export const getInclusionIcon = switchFunc(INCLUSION_ICONS, LineCheckIcon)
